import Vue from 'vue'

interface IWebpartRegistration {
    /**
     * 컴포넌트를 전역에 등록합니다.
     * @param name  컴포넌트 이름
     * @param component 컴포넌트
     */
    register(name: string, component: any, type?: string, description?: string, displayName?:string): void

    /**
     * 등록된 컴포넌트 이름 목록을 가져옵니다.
     */
    names(): string[]

    /**
     * 등록된 컴포넌트 정보를 가져옵니다.
     */
    components(): RegisteredComponentInfo[]
}

export type RegisteredComponentInfo = {
    name: string
    type?: string
    description?: string
    displayName?: string
}

class WebpartRegistration implements IWebpartRegistration {
    table: Map<string, RegisteredComponentInfo> = new Map<string, RegisteredComponentInfo>()

    register(name: string, component: any, type: string='', description?: string, displayName?: string): void {
        if (this.table.get(name)) throw new Error(`Failed to register component. Name ${name} already exists.`)
        Vue.component(name, component)
        this.table.set(name, {name, type, description, displayName})
    }

    names(): string[] {
        return Array.from(this.table.keys())
    }

    components(): RegisteredComponentInfo[] {
        return Array.from(this.table.values())
    }
}

const webpartRegister = new WebpartRegistration() as IWebpartRegistration
export default webpartRegister

